import PropTypes from 'prop-types';

const componentDetail = 'Modal';
const builderConfig = {
  helper: {
    title: {
      type: 'string',
      required: true,
      max: { max: 35, message: `Max length is 35` },
    },
    description: {
      type: 'long',
      required: true,
      max: { max: 180, message: `Max length is 180` },
    },
    image: { type: 'url', required: false },
  },
};

const propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

const defaultProps = {
  title: 'Title',
  description: 'Description',
  visible: false,
};

export default { componentDetail, builderConfig, propTypes, defaultProps };
